module.exports = __webpack_public_path__ + "media/svg/al-6ea23f78.svg";